((global) => {
  const catalog = [
  {
    "key": "montserrat",
    "family": "Montserrat",
    "weight": 900,
    "variable": true,
    "cyrillic": true,
    "group": "Sans serif",
    "offered": true,
    "label": "Montserrat Black"
  },
  {
    "key": "oswald",
    "family": "Oswald",
    "weight": 700,
    "variable": true,
    "cyrillic": true,
    "group": "Condensed",
    "offered": true,
    "label": "Oswald Bold"
  },
  {
    "key": "rubik",
    "family": "Rubik",
    "weight": 900,
    "variable": true,
    "cyrillic": true,
    "group": "Sans serif",
    "offered": false,
    "label": "Rubik Black"
  },
  {
    "key": "anton",
    "family": "Anton",
    "weight": 400,
    "variable": false,
    "cyrillic": false,
    "group": "Display",
    "offered": true,
    "label": "Anton"
  },
  {
    "key": "archivoblack",
    "family": "Archivo Black",
    "weight": 400,
    "variable": false,
    "cyrillic": false,
    "group": "Display",
    "offered": true,
    "label": "Archivo Black"
  },
  {
    "key": "archivo",
    "family": "Archivo",
    "weight": 900,
    "variable": true,
    "cyrillic": false,
    "group": "Sans serif",
    "offered": true,
    "label": "Archivo 900"
  },
  {
    "key": "barlow",
    "family": "Barlow",
    "weight": 900,
    "variable": false,
    "cyrillic": false,
    "group": "Sans serif",
    "offered": false,
    "label": "Barlow Black"
  },
  {
    "key": "barlowcondensed",
    "family": "Barlow Condensed",
    "weight": 900,
    "variable": false,
    "cyrillic": false,
    "group": "Condensed",
    "offered": false,
    "label": "Barlow Condensed Black"
  },
  {
    "key": "barlowsemicondensed",
    "family": "Barlow Semi Condensed",
    "weight": 900,
    "variable": false,
    "cyrillic": false,
    "group": "Condensed",
    "offered": false,
    "label": "Barlow Semi Condensed Black"
  },
  {
    "key": "bungee",
    "family": "Bungee",
    "weight": 400,
    "variable": false,
    "cyrillic": false,
    "group": "Display",
    "offered": true,
    "label": "Bungee"
  },
  {
    "key": "changa",
    "family": "Changa",
    "weight": 800,
    "variable": true,
    "cyrillic": false,
    "group": "Sans serif",
    "offered": false,
    "label": "Changa ExtraBold"
  },
  {
    "key": "changaone",
    "family": "Changa One",
    "weight": 400,
    "variable": false,
    "cyrillic": false,
    "group": "Display",
    "offered": false,
    "label": "Changa One"
  },
  {
    "key": "chivo",
    "family": "Chivo",
    "weight": 900,
    "variable": true,
    "cyrillic": false,
    "group": "Sans serif",
    "offered": false,
    "label": "Chivo Black"
  },
  {
    "key": "delagothicone",
    "family": "Dela Gothic One",
    "weight": 400,
    "variable": false,
    "cyrillic": true,
    "group": "Display",
    "offered": false,
    "label": "Dela Gothic One"
  },
  {
    "key": "exo2",
    "family": "Exo 2",
    "weight": 900,
    "variable": true,
    "cyrillic": true,
    "group": "Sans serif",
    "offered": false,
    "label": "Exo 2 Black"
  },
  {
    "key": "figtree",
    "family": "Figtree",
    "weight": 900,
    "variable": true,
    "cyrillic": false,
    "group": "Sans serif",
    "offered": false,
    "label": "Figtree Black"
  },
  {
    "key": "fredoka",
    "family": "Fredoka",
    "weight": 700,
    "variable": true,
    "cyrillic": false,
    "group": "Sans serif",
    "offered": true,
    "label": "Fredoka Bold"
  },
  {
    "key": "fugazone",
    "family": "Fugaz One",
    "weight": 400,
    "variable": false,
    "cyrillic": false,
    "group": "Display",
    "offered": false,
    "label": "Fugaz One"
  },
  {
    "key": "heebo",
    "family": "Heebo",
    "weight": 900,
    "variable": true,
    "cyrillic": false,
    "group": "Sans serif",
    "offered": false,
    "label": "Heebo Black"
  },
  {
    "key": "hind",
    "family": "Hind",
    "weight": 700,
    "variable": false,
    "cyrillic": false,
    "group": "Sans serif",
    "offered": false,
    "label": "Hind Bold"
  },
  {
    "key": "ibmplexsans",
    "family": "IBM Plex Sans",
    "weight": 700,
    "variable": true,
    "cyrillic": true,
    "group": "Sans serif",
    "offered": false,
    "label": "IBM Plex Sans Bold"
  },
  {
    "key": "ibmplexsanscondensed",
    "family": "IBM Plex Sans Condensed",
    "weight": 700,
    "variable": false,
    "cyrillic": false,
    "group": "Condensed",
    "offered": false,
    "label": "IBM Plex Sans Condensed Bold"
  },
  {
    "key": "inter",
    "family": "Inter",
    "weight": 900,
    "variable": true,
    "cyrillic": true,
    "group": "Sans serif",
    "offered": true,
    "label": "Inter Black"
  },
  {
    "key": "jost",
    "family": "Jost",
    "weight": 900,
    "variable": true,
    "cyrillic": true,
    "group": "Sans serif",
    "offered": false,
    "label": "Jost Black"
  },
  {
    "key": "kanit",
    "family": "Kanit",
    "weight": 900,
    "variable": false,
    "cyrillic": false,
    "group": "Sans serif",
    "offered": false,
    "label": "Kanit Black"
  },
  {
    "key": "karla",
    "family": "Karla",
    "weight": 800,
    "variable": true,
    "cyrillic": false,
    "group": "Sans serif",
    "offered": false,
    "label": "Karla ExtraBold"
  },
  {
    "key": "lato",
    "family": "Lato",
    "weight": 900,
    "variable": false,
    "cyrillic": true,
    "group": "Sans serif",
    "offered": false,
    "label": "Lato Black"
  },
  {
    "key": "lexend",
    "family": "Lexend",
    "weight": 900,
    "variable": true,
    "cyrillic": false,
    "group": "Sans serif",
    "offered": false,
    "label": "Lexend Black"
  },
  {
    "key": "lilitaone",
    "family": "Lilita One",
    "weight": 400,
    "variable": false,
    "cyrillic": false,
    "group": "Display",
    "offered": false,
    "label": "Lilita One"
  },
  {
    "key": "manrope",
    "family": "Manrope",
    "weight": 800,
    "variable": true,
    "cyrillic": true,
    "group": "Sans serif",
    "offered": false,
    "label": "Manrope ExtraBold"
  },
  {
    "key": "mavenpro",
    "family": "Maven Pro",
    "weight": 900,
    "variable": true,
    "cyrillic": false,
    "group": "Sans serif",
    "offered": false,
    "label": "Maven Pro Black"
  },
  {
    "key": "merriweathersans",
    "family": "Merriweather Sans",
    "weight": 800,
    "variable": true,
    "cyrillic": false,
    "group": "Sans serif",
    "offered": false,
    "label": "Merriweather Sans ExtraBold"
  },
  {
    "key": "mukta",
    "family": "Mukta",
    "weight": 800,
    "variable": false,
    "cyrillic": false,
    "group": "Sans serif",
    "offered": false,
    "label": "Mukta ExtraBold"
  },
  {
    "key": "mulish",
    "family": "Mulish",
    "weight": 900,
    "variable": true,
    "cyrillic": true,
    "group": "Sans serif",
    "offered": false,
    "label": "Mulish Black"
  },
  {
    "key": "notosans",
    "family": "Noto Sans",
    "weight": 900,
    "variable": true,
    "cyrillic": true,
    "group": "Sans serif",
    "offered": true,
    "label": "Noto Sans Black"
  },
  {
    "key": "nunito",
    "family": "Nunito",
    "weight": 900,
    "variable": true,
    "cyrillic": true,
    "group": "Sans serif",
    "offered": false,
    "label": "Nunito Black"
  },
  {
    "key": "nunitosans",
    "family": "Nunito Sans",
    "weight": 900,
    "variable": true,
    "cyrillic": true,
    "group": "Sans serif",
    "offered": false,
    "label": "Nunito Sans Black"
  },
  {
    "key": "outfit",
    "family": "Outfit",
    "weight": 900,
    "variable": true,
    "cyrillic": false,
    "group": "Sans serif",
    "offered": false,
    "label": "Outfit Black"
  },
  {
    "key": "overpass",
    "family": "Overpass",
    "weight": 900,
    "variable": true,
    "cyrillic": true,
    "group": "Sans serif",
    "offered": false,
    "label": "Overpass Black"
  },
  {
    "key": "poppins",
    "family": "Poppins",
    "weight": 900,
    "variable": false,
    "cyrillic": false,
    "group": "Sans serif",
    "offered": false,
    "label": "Poppins Black"
  },
  {
    "key": "prompt",
    "family": "Prompt",
    "weight": 900,
    "variable": false,
    "cyrillic": false,
    "group": "Sans serif",
    "offered": false,
    "label": "Prompt Black"
  },
  {
    "key": "publicsans",
    "family": "Public Sans",
    "weight": 900,
    "variable": true,
    "cyrillic": false,
    "group": "Sans serif",
    "offered": false,
    "label": "Public Sans Black"
  },
  {
    "key": "raleway",
    "family": "Raleway",
    "weight": 900,
    "variable": true,
    "cyrillic": true,
    "group": "Sans serif",
    "offered": false,
    "label": "Raleway Black"
  },
  {
    "key": "readexpro",
    "family": "Readex Pro",
    "weight": 700,
    "variable": true,
    "cyrillic": false,
    "group": "Sans serif",
    "offered": false,
    "label": "Readex Pro Bold"
  },
  {
    "key": "redhatdisplay",
    "family": "Red Hat Display",
    "weight": 900,
    "variable": true,
    "cyrillic": false,
    "group": "Sans serif",
    "offered": false,
    "label": "Red Hat Display Black"
  },
  {
    "key": "roboto",
    "family": "Roboto",
    "weight": 900,
    "variable": true,
    "cyrillic": true,
    "group": "Sans serif",
    "offered": false,
    "label": "Roboto Black"
  },
  {
    "key": "robotocondensed",
    "family": "Roboto Condensed",
    "weight": 900,
    "variable": true,
    "cyrillic": true,
    "group": "Condensed",
    "offered": false,
    "label": "Roboto Condensed Black"
  },
  {
    "key": "rowdies",
    "family": "Rowdies",
    "weight": 700,
    "variable": false,
    "cyrillic": false,
    "group": "Display",
    "offered": false,
    "label": "Rowdies Bold"
  },
  {
    "key": "russoone",
    "family": "Russo One",
    "weight": 400,
    "variable": false,
    "cyrillic": true,
    "group": "Display",
    "offered": false,
    "label": "Russo One"
  },
  {
    "key": "saira",
    "family": "Saira",
    "weight": 900,
    "variable": true,
    "cyrillic": false,
    "group": "Condensed",
    "offered": false,
    "label": "Saira Black"
  },
  {
    "key": "worksans",
    "family": "Work Sans",
    "weight": 700,
    "variable": true,
    "cyrillic": false,
    "group": "Sans serif",
    "offered": true,
    "style": "normal",
    "label": "Work Sans Bold"
  },
  {
    "key": "robotoslab",
    "family": "Roboto Slab",
    "weight": 900,
    "variable": true,
    "cyrillic": true,
    "group": "Serif",
    "offered": true,
    "style": "normal",
    "label": "Roboto Slab Black"
  },
  {
    "key": "jetbrainsmono",
    "family": "JetBrains Mono",
    "weight": 800,
    "variable": true,
    "cyrillic": true,
    "group": "Monospace",
    "offered": true,
    "style": "normal",
    "label": "JetBrains Mono ExtraBold"
  },
  {
    "key": "arimo",
    "family": "Arimo",
    "weight": 700,
    "variable": true,
    "cyrillic": true,
    "group": "Sans serif",
    "offered": true,
    "style": "normal",
    "label": "Arimo Bold"
  },
  {
    "key": "tektur",
    "family": "Tektur",
    "weight": 700,
    "variable": true,
    "cyrillic": true,
    "group": "Display",
    "offered": true,
    "style": "normal",
    "label": "Tektur Bold"
  },
  {
    "key": "postbuspro",
    "family": "PostBus Pro",
    "weight": 400,
    "variable": false,
    "cyrillic": true,
    "group": "Display",
    "offered": true,
    "style": "normal",
    "label": "PostBus Pro"
  },
  {
    "key": "xanmono",
    "family": "Xanmono",
    "weight": 400,
    "variable": false,
    "cyrillic": true,
    "group": "Display",
    "offered": true,
    "style": "normal",
    "label": "Xanmono"
  },
  {
    "key": "robtronika",
    "family": "Robtronika",
    "weight": 400,
    "variable": false,
    "cyrillic": true,
    "group": "Display",
    "offered": true,
    "style": "normal",
    "label": "Robtronika"
  },
  {
    "key": "baloo2",
    "family": "Baloo 2",
    "weight": 700,
    "variable": true,
    "cyrillic": false,
    "group": "Sans serif",
    "offered": true,
    "style": "normal",
    "label": "Baloo 2 Bold"
  },
  {
    "key": "zillaslab",
    "family": "Zilla Slab",
    "weight": 700,
    "variable": false,
    "cyrillic": false,
    "group": "Serif",
    "offered": true,
    "style": "normal",
    "label": "Zilla Slab Bold"
  },
  {
    "key": "bitter",
    "family": "Bitter",
    "weight": 700,
    "variable": true,
    "cyrillic": true,
    "group": "Serif",
    "offered": true,
    "style": "normal",
    "label": "Bitter Bold"
  },
  {
    "key": "permanentmarker",
    "family": "Permanent Marker",
    "weight": 400,
    "variable": false,
    "cyrillic": false,
    "group": "Display",
    "offered": true,
    "style": "normal",
    "label": "Permanent Marker"
  },
  {
    "key": "bangers",
    "family": "Bangers",
    "weight": 400,
    "variable": false,
    "cyrillic": false,
    "group": "Display",
    "offered": true,
    "style": "normal",
    "label": "Bangers"
  },
  {
    "key": "montserratitalic",
    "family": "Montserrat",
    "weight": 900,
    "variable": true,
    "cyrillic": true,
    "group": "Sans serif",
    "offered": true,
    "style": "italic",
    "label": "Montserrat Black Italic"
  }
];
  global.RollMyLogoFonts = catalog;
  if (typeof module !== 'undefined') module.exports = catalog;
})(typeof window !== 'undefined' ? window : globalThis);
